import { Vector2, Vector3 } from '@technology/web3d-plugin-threejs';
/*
 * A simple object pool to reuse Vector2 and Vector3 instances.
 * This helps to reduce garbage collection and improve performance
 * when processing large amounts of quantized mesh data.
 * The important thing to keep in mind is that these objects
 * should only be used for ephemeral calculations. If you store them
 * on an object, they will be overwritten in the next cycle, which may
 * not be what you want.
 */
export class ObjectPool {
  private readonly vector3Pool: Vector3[] = [];
  private vector3Index = 0;

  private readonly vector2Pool: Vector2[] = [];
  private vector2Index = 0;

  public getVector3(): Vector3 {
    if (this.vector3Index < this.vector3Pool.length) {
      return this.vector3Pool[this.vector3Index++];
    } else {
      const newVec = new Vector3();
      this.vector3Pool.push(newVec);
      this.vector3Index++;
      return newVec;
    }
  }

  public getVector2(): Vector2 {
    if (this.vector2Index < this.vector2Pool.length) {
      return this.vector2Pool[this.vector2Index++];
    } else {
      const newVec = new Vector2();
      this.vector2Pool.push(newVec);
      this.vector2Index++;
      return newVec;
    }
  }

  public reset(): void {
    this.vector2Index = 0;
    this.vector3Index = 0;
  }
}
